import { useCurrentUser } from "../../../hooks/useCurrentUser.ts";
import ItemBookmarkController from "../../user/controller/ItemBookmarkController.tsx";
import { ReactNode } from "react";

const FavoriteItem = ({
  itemId,
  className,
  favoriteActiveChildren,
  favoriteInactiveChildren,
}: {
  itemId: string;
  className?: string;
  favoriteActiveChildren: ReactNode;
  favoriteInactiveChildren: ReactNode;
}) => {
  const currentUser = useCurrentUser();
  return (
    <ItemBookmarkController itemId={itemId} userId={currentUser}>
      {(handleBookmark, loading, error, isBookmarked) => (
        <button
          className={`btn ${className} active:text-error ${isBookmarked && "text-error"} ${loading && "btn-disabled animate-pulse"} ${error && "btn-error"}`}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleBookmark();
          }}
        >
          {isBookmarked ? favoriteActiveChildren : favoriteInactiveChildren}
        </button>
      )}
    </ItemBookmarkController>
  );
};
export default FavoriteItem;
